export var adminBaseRoute = '/portal-admin/';
export var appRoutesEndpoints = {
    homePage: '/',
    careDashboard: '/care-dashboard',
    caseManagement: '/case-management',
    admin: {
        baseRoute: adminBaseRoute,
        nestedRoutes: {
            announcement: {
                baseRoute: "announcement",
            },
            careInsightReview: {
                baseRoute: "care-insight-review",
            },
            corporateAndFacilities: {
                baseRoute: "corporate-agencies",
            },
            facilities: {
                baseRoute: "corporate-agencies/:corporateId'",
            },
            accounts: {
                baseRoute: "accounts",
            },
            vimientUsers: {
                baseRoute: "clearwellness-users",
            },
            corporateUsers: {
                baseRoute: "corporate-users",
            },
            cWMemberRecordsUsers: {
                baseRoute: "cWMemberRecords-users",
            },
            caregiverUsers: {
                baseRoute: "caregiver-users",
            },
            agentSchedule: {
                baseRoute: "agent-schedule",
            },
            poaReview: {
                baseRoute: "poa-review",
            },
            assessment: {
                baseRoute: "assessment",
            },
            wellnesSurvey: {
                baseRoute: "wellness-survey",
            },
            holisticAssessment: {
                baseRoute: "holistic-assessment",
            },
            medicalCondition: {
                baseRoute: "medical-condition",
            },
            aDLAssessment: {
                baseRoute: "adl-assessment",
            },
            memberQuestionnaire: {
                baseRoute: "member-questionnaire",
            },
            cIRangeMilestones: {
                baseRoute: "ci-range-milestones",
            },
            caregiver: {
                baseRoute: "caregiver-assessment",
            },
            cgAssessment: {
                baseRoute: "cg-assessment",
            },
            cgReport: {
                baseRoute: "cg-report",
            },
            assignment: {
                baseRoute: 'assignment',
            },
            seniorCoach: {
                baseRoute: 'senior-coach',
            },
            agentCoach: {
                baseRoute: 'agent-coach',
            },
            adminReports: {
                baseRoute: 'reports',
            },
            adminScheduledReports: {
                baseRoute: 'schedule-reports',
            },
            adminTools: {
                baseRoute: 'adminTools',
            },
            caregiverRelease: {
                baseRoute: 'caregiver-MobileApp-release',
            },
            UCLALonelinessAssessment: {
                baseRoute: "uCLALoneliness-assessment",
            },
            fallsAndHospitalizationAssessment: {
                baseRoute: "fallsAndHospitalization-assessment",
            },
            homeSafetyAssessment: {
                baseRoute: "homeSafety-assessment",
            },
            templateManagement: {
                baseRoute: 'templateManagement',
            },
            sbarDetails: {
                baseRoute: 'sbarDetails',
            },
            prioritiesAndChallenges: {
                baseRoute: 'prioritiesandchallenges',
            },
            callEntry: {
                baseRoute: 'callentry',
            },
        },
    },
    taskManagement: '/task',
    devicehealth: '/device-health',
    facilityAgent: {
        baseRoute: '/facility-management',
    },
    deviceInfo: '/device-info',
};
